































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DocsendUser } from '../DocsendUser';
import * as utils_auth from '../utils_auth';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

interface Link {
  name: string
  path: string
}

@Component({
  name: 'the-navbar',
  components: {
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue'),
  }
})
export default class TheNavbarComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public links: Link[] = []

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): DocsendUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public async userChoseSignOut() {
    await utils_auth.logout()
  }
  public userChoseLogin(): void {
    utils_auth.setLocationAfterLogin({ name: "docs" });
    (this.$refs.LoginFormModalComponent as ModalWrapperComponent).show(null, 'sm', null)
  }
  public userChoseRegister(): void {
    utils_auth.setLocationAfterLogin({ name: "docs" });
    (this.$refs.RegisterFormModalComponent as ModalWrapperComponent).show('Sign Up', 'sm', null)
  }

  // private, non-reactive member variables
  private tab: string = null

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    this.doTabs()
    this.tab = this.$route.path.split('/')[1]

    if (this.$store.state.devmode) console.log(`navbar.pathChanged() ${this.$route.path} => this.tab: ${this.tab}`)
  }

  private mounted(): void {
    this.doTabs()
  }

  // private functions not available directly to HTML template
  private doTabs(): void {
    this.links = []
    this.links.push({ name: 'Docs', path: '/docs' })
    this.links.push({ name: 'Bookmarked', path: '/bookmarked' })
  }

}
